export const textInHooks = (string) => {
  const availableCaptions = ['4К Quality[+]', 'Панорама 360 4K', 'Панорама 360 8K', 'Panorama 360 4K', 'Panorama 360 8K', 'FullHD', 'QHD', 'HD'];
  const getCaption = () => {
    for (let i = 0; i < availableCaptions.length; i++) {
      const searchString = string.match(availableCaptions[i]);

      if (searchString) {
        return searchString[0];
      }
    }
  };
  const getResolution = () => string.match(/\d+[×xх*]\d+/g);

  const textHooks = getCaption();
  const result = {};

  if (textHooks) {
    result.out_hooks = textHooks;
    result.in_hooks = textHooks.match('VR-') ? '' : getResolution();
    result.display = true;
  } else {
    result.out_hooks = string;
    result.in_hooks = '';
    result.display = false;
  }

  return result;
};
